import type { Transactable } from '@src/domains/transactables/types/transactable';

/**
 * What the buyer is charged, in cents. Every shape carries a total, each under its own name — and
 * the direct link's `totalAmountCents` is deprecated in favour of the currency info.
 */
export const resolveTransactableAmountCents = (tr: Transactable): number => {
  if (tr.saleChange) {
    return tr.saleChange.amount.amountCents;
  }

  if (tr.order) {
    return tr.order.finalAmountCents;
  }

  if (tr.sale) {
    return tr.sale.totalAmountCents;
  }

  if (tr.directLink) {
    return tr.directLink.totalAmountCurrencyInfo?.amountCents ?? 0;
  }

  return 0;
};
